import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_ID,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);

export const storageErrorMessage = (fn, error, filename) => {
  let message = `[${fn}] Error: `;
  switch (error.code) {
    case 'storage/object-not-found':
      message += `${filename} file is doesn't exist`;
      break;
    case 'storage/unauthorized':
      message += `User doesn't have permission to access the '${filename}' file`;
      break;
    case 'storage/canceled':
      message += `User canceled the upload ${filename} file`;
      break;
    case 'storage/unknown':
      message += 'Unknown error occurred, inspect the server respons';
      break;
    default:
      message += error;
      break;
  }
  console.log(message);
};
